module.exports = __webpack_public_path__ + "static/media/Medal-3.04a5f93b.svg";